<template>
  <button
    :type="type"
    class="relative right-1 flex items-center justify-center overflow-hidden rounded-full border border-gray-600 px-8 py-3 font-medium ring-0 duration-500 hover:border-opacity-75 hover:bg-opacity-75 focus:outline-none focus:ring-2 focus:ring-blue-300 disabled:cursor-wait"
    :class="[
      kind === FormButtonKind.FILLED
        ? 'bg-gray-600 text-white'
        : kind === FormButtonKind.OUTLINED
          ? 'bg-white text-gray-600'
          : ''
    ]"
    :disabled="state === FormState.LOADING">
    <span
      v-if="state === FormState.LOADING"
      class="absolute flex h-[1.5em] items-center justify-center">
      <svg
        class="h-5 w-5 animate-spin text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24">
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4" />
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
      </svg>
    </span>
    <span
      class="flex h-[1.5em] items-center justify-center"
      :class="{ invisible: state === FormState.LOADING }">
      {{ label }}
    </span>
  </button>
</template>

<script setup lang="ts">
  import { FormButtonKind, FormState } from '~/constants/form'

  type FormButtonProps = {
    type?: 'button' | 'submit' | 'reset'
    kind?: FormButtonKind
    state?: FormState
    label: string
  }

  withDefaults(defineProps<FormButtonProps>(), {
    type: 'button',
    kind: FormButtonKind.FILLED,
    state: FormState.IDLE
  })
</script>
